import { PopulatedWallet } from "@syla/shared/types/models/WalletBase";
import { DataSourceInputType } from "../../../../helper/dataSource/DataSourceInputType";
import { getSupportedImportMethods } from "./getSupportedImportMethods";

export type FileImportMethod =
  | DataSourceInputType.Csv
  | DataSourceInputType.Custom;

const FILE_IMPORT_METHODS: FileImportMethod[] = [
  DataSourceInputType.Csv,
  DataSourceInputType.Custom,
];

export function getSupportedFileImportMethods(
  wallet: PopulatedWallet,
): FileImportMethod[] {
  const supported = getSupportedImportMethods(wallet.dataSource);
  return supported.filter((method): method is FileImportMethod =>
    FILE_IMPORT_METHODS.includes(method as FileImportMethod),
  );
}
